import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import CustomPaperBox from "../../components/common/CustomPaperBox";
import { LuUsers } from "react-icons/lu";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import PageHeader from "../../components/layout/LayoutWrapper/PageHeader";
import Grid from "../../components/layout/grid/Grid";
import Text from "../../components/typography/Text";
import CustomDropdownMenu from "../../components/CustomDropdownMenu";
import CustomTextInputBasic from "../../components/common/CustomTextInput/CustomTextInputBasic";
import AdminLeadEngagement from "../../components/LeadEngagement/AdminLeadEngagement";
import {
  getCompanyRegionsUrl,
  getRMList,
  assignRMToLead,
  getLeadDetailsUrl,
} from "../../utils/urls";
import { errorToast, successToast } from "../../utils/toasts";
import CustomSelectBasic from "../../components/common/CustomSelect/CustomSelectBasic";
import axios from "axios";
import Select from "react-select";
import AssignRelationshipManagerToLead from "./AssignRelationshipManagerToLead";
import { hideLoader, showLoader } from "../../utils/loader";
import { useSelector } from "react-redux";

const LeadDetailsPage = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const location = useLocation();
  const lead = location.state?.lead;
  const [selectedRegions, setSelectedRegions] = useState([]);

  const [selectedManager, setSelectedManager] = useState("Select");
  const [contactError, setContactError] = useState("");
  const [leadDetails, setLeadDetails] = useState();
  const [stateList, setStateList] = useState([]);

  const [assignRmModalData, setAssignRmModalData] = useState(null);

  async function getLeadDetails() {
    try {
      showLoader("Fetching Lead data...");
      const response = await axios.get(
        getLeadDetailsUrl + `/${lead?.lead_product_relation_display_id}`
      );
      console.log("data getLeadDetailsUrl", response.data.data);
      if (response.data.success) {
        const leadDetails = response.data.data;
        setLeadDetails(leadDetails);
        console.log("get lead details", leadDetails);

        if (
          leadDetails?.lead_product_relationship_manager_relation
            ?.relationship_manager_id
        ) {
          setSelectedManager(
            leadDetails.lead_product_relationship_manager_relation
              .relationship_manager_id
          );
          console.log(
            "leadDetails.lead_product_relationship_manager_relation.elationship_manager_id",
            leadDetails.lead_product_relationship_manager_relation
              .relationship_manager_id
          );
        }

        if (
          leadDetails?.lead_product_relationship_manager_relation
            ?.relationship_manager_id?.region
        ) {
          console.log(
            leadDetails?.lead_product_relationship_manager_relation
              ?.relationship_manager_id?.region
          );

          const formatedSelectedRegions =
            leadDetails?.lead_product_relationship_manager_relation?.relationship_manager_id?.region.map(
              (region) => {
                return {
                  value: region.region_id.region_id,
                  label: region.region_id.title,
                };
              }
            );
          setSelectedRegions(formatedSelectedRegions);
          setStateList(
            leadDetails.lead_product_relationship_manager_relation
              .relationship_manager_id.region
          );
        }
      }
    } catch (err) {
      console.log("lead err: ", err);
      errorToast("Error fetching lead!");
    } finally {
      hideLoader();
    }
  }

  useEffect(() => {
    getLeadDetails();
  }, []);

  const renderButtons = useMemo(() => {
    return (
      <>
        {(leadDetails?.lead_product_relationship_manager_relation) ?
          <>
            {leadDetails?.product_id ? 
              <CustomButton
                label="Re-Assign TO Company Manager"
                disabled={!Boolean(leadDetails)}
                onClick={() => {
                  setAssignRmModalData({actionType: "Assign TO Company Manager"})
                }}
              />
              :
              <>
                <CustomButton
                  label="Re-Assign TO Admin Manager"
                  disabled={!Boolean(leadDetails)}
                  onClick={() => {
                    setAssignRmModalData({actionType: "Assign TO Admin Manager"})
                  }}
                />
                <CustomButton
                  label="Re-Assign TO Company Manager"
                  disabled={!Boolean(leadDetails)}
                  onClick={() => {
                    setAssignRmModalData({actionType: "Assign TO Company Manager"})
                  }}
                />
              </>
            }
          </>
          :
          <>
            {leadDetails?.product_id ? 
              <CustomButton
                label="Assign TO Company Manager"
                disabled={!Boolean(leadDetails)}
                onClick={() => {
                  setAssignRmModalData({actionType: "Assign TO Company Manager"})
                }}
              />
              :
              <CustomButton
                label="Assign TO Admin Manager"
                disabled={!Boolean(leadDetails)}
                onClick={() => {
                  setAssignRmModalData({actionType: "Assign TO Admin Manager"})
                }}
              />
            }
          </>
        }



            {/* {!(leadDetails?.product_id) && 
              <>
                <CustomButton
                  label="Assign TO Company Manager"
                  disabled={!Boolean(leadDetails)}
                  onClick={() => {
                    
                  }}
                />
                {leadDetails?.lead_product_relationship_manager_relation &&
                  <CustomButton
                    label="Re-Assign To Admin Manager"
                    disabled={!Boolean(leadDetails)}
                    onClick={() => {

                    }}
                  />
                }
              </>
            } */}
      </>
    )
  }, [leadDetails])

  return (
    <div className="space-y-5">
      <PageHeader title="Assigned Manager" showBack size="md" />

      <CustomPaperBox className="p-6 mt-4" elevation="none" variant="default">
        <Grid
          className="items-center gap-4"
          xs={12}
          md={12}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Grid
            item
            xs={2}
            md={1}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="bg-[#F0FAFF] w-14 h-14 rounded-lg flex items-center justify-center">
              <LuUsers className="w-6 h-6 text-[#0F2F54]" />
            </div>
          </Grid>

          <Grid item xs={10} md={11}>
            <Text variant="h2-title">{leadDetails?.lead_id?.name || ""} </Text>
          </Grid>
        </Grid>

        <Grid gap={12} className="mt-4 w-full" xs={12} md={12}>
          <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500">Priority :</span>{" "}
              <span className="text-yellow-600 font-semibold">
                {lead?.priority || "Low"}
              </span>
            </Text>
          </Grid>
          <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500">Status :</span>{" "}
              <span className="bg-green-100 text-green-600 px-7 py-1 rounded-lg">
                {lead?.lead_status_title || "low"}
              </span>
            </Text>
          </Grid>

          <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500">Mobile No. :</span>{" "}
              <span className="font-semibold">
                {leadDetails?.lead_id?.contact_number || "NA"}
              </span>
            </Text>
          </Grid>
          <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500">Email :</span>{" "}
              <span className="font-semibold">
                {leadDetails?.lead_id?.email || "NA"}
              </span>
            </Text>
          </Grid>

          <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500">Date Of Birth :</span>{" "}
              <span className="font-semibold">
                {leadDetails?.lead_id?.dob || "NA"}
              </span>
            </Text>
          </Grid>

          <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500"> Address:</span>{" "}
              <span className="font-semibold">
                {leadDetails?.lead_id.address || "NA"}
              </span>
            </Text>
          </Grid>

          <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500">City :</span>{" "}
              <span className="font-semibold">
                {leadDetails?.lead_id?.city_id?.title || "NA"}
              </span>
            </Text>
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500">Advisor :</span>{" "}
              <span className="font-semibold">{lead?.advisor_name
                || "john"}</span>
            </Text>
          </Grid> */}
          <Grid item xs={12} md={6}>
            <Text variant="para-s">
              <span className="text-gray-500">State :</span>{" "}
              <span className="font-semibold">
                {leadDetails?.lead_id?.city_id?.state_id?.title || "NA"}
              </span>
            </Text>
          </Grid>
        </Grid>
      </CustomPaperBox>

      {/* Advisor details */}

      <CustomPaperBox className="p-6 mt-4" elevation="none" variant="default">
        <h2 className="text-lg font-semibold mb-4">Advisor Details</h2>

        <Grid container spacing={4} className="mt-4 w-full">
          <Grid item xs={12} md={4}>
            <Text variant="para-s">
              <span className="text-gray-500">Advisor :</span>{" "}
              <span className="font-semibold">
                {leadDetails?.advisor_id?.name || "John Doe"}
              </span>
            </Text>
          </Grid>

          <Grid item xs={12} md={4}>
            <Text variant="para-s">
              <span className="text-gray-500">Type :</span>{" "}
              <span className="font-semibold">
                {leadDetails?.advisor_id?.join_as || "General Insurance"}
              </span>
            </Text>
          </Grid>

          <Grid item xs={12} md={4}>
            <Text variant="para-s">
              <span className="text-gray-500">Date :</span>{" "}
              <span className="font-semibold">
                {leadDetails?.advisor_id?.created_at
                  ? new Date(lead.created_at).toLocaleDateString("en-GB")
                  : "01/02/2025"}
              </span>
            </Text>
          </Grid>

          <Grid item xs={12} md={4}>
            <Text variant="para-s">
              <span className="text-gray-500">Commission :</span>{" "}
              <span className="font-semibold">
                <span className="font-semibold">
                  ₹
                  {leadDetails?.before_issuance_excel_data_id
                    ?.commission_amount || "0.00"}
                </span>
              </span>
            </Text>
          </Grid>

          <Grid item xs={12} md={4}>
            <Text variant="para-s">
              <span className="text-gray-500">Amount :</span>{" "}
              <span className="font-semibold">
                ₹
                {leadDetails?.before_issuance_excel_data_id?.policy_amount ||
                  "0.00"}
              </span>
            </Text>
          </Grid>
        </Grid>
      </CustomPaperBox>

      {/* Product intrest */}
      <CustomPaperBox className="p-6 mt-4" elevation="none" variant="default">
        {/* Title */}
        <h2 className="text-lg font-semibold mb-4">Product Interest</h2>

        {/* Product Name */}
        <p className="text-base font-semibold mb-4">
          {leadDetails?.sub_category_id?.title ||
            leadDetails?.category_id?.title ||
            leadDetails?.product_id?.product_name ||
            "NA"}
        </p>

        {/* Description */}
        <div className="mb-4">
          <p className="text-sm text-gray-500 mb-1">Description</p>
          <span className="font-semibold">
            {leadDetails?.sub_category_id?.description ||
              leadDetails?.category_id?.description ||
              leadDetails?.product_id?.description ||
              "Description details not available."}
          </span>
        </div>

        {/* Key Benefits */}
        {leadDetails?.product_id?.financial_description && (
          <div>
            <p className="text-sm text-gray-500 mb-1">Financial Description</p>
            <span className="font-semibold">
              {leadDetails?.product_id?.financial_description ||
                "Financial Description not available."}
            </span>
          </div>
        )}
      </CustomPaperBox>

      <CustomPaperBox variant="default" className="mt-3">
        <h2 className="text-lg font-semibold mb-4">Manager Details</h2>
        <Grid container spacing={4}>
          {(leadDetails?.lead_product_relationship_manager_relation?.relationship_manager_id?.region?.length > 0) &&
            <Grid item md={4}>
              {/* <div className="w-full">
                <Text variant="para-s">Region/Area</Text>
                <Select
                  isMulti
                  options={regions}
                  value={selectedRegions}
                  onChange={handleChange}
                  placeholder="Select regions"
                  className="w-full"
                />
              </div> */}
              
                <CustomTextInputBasic
                  label="Region/Area"
                  name="region"
                  type="text"
                  className="w-full -mt-1"
                  value={leadDetails?.lead_product_relationship_manager_relation?.relationship_manager_id?.region[0]?.region_id?.title}
                  // onChange={handleContactChange}
                  // maxLength={10}
                  disabled
                />
            </Grid>
          }

          {leadDetails?.lead_product_relationship_manager_relation?.relationship_manager_id?.name &&
            <Grid item md={4}>
              {/* <div className="w-full"> */}
                {/* <Text variant="para-s">Manager Details</Text> */}
                {/* <CustomDropdownMenu
                  position="right"
                  label={selectedManager.name}
                  className="bg-gray-100 rounded-md w-full"
                  list={managers?.map((manager) => ({
                    label: manager.name,
                    onClick: () => {
                      console.log("making it true");

                      setIsChanged(true);
                      setSelectedManager(manager);
                    },
                  }))}
                /> */}
                <CustomTextInputBasic
                  label="Name"
                  name="name"
                  type="text"
                  className="w-full -mt-1"
                  value={leadDetails?.lead_product_relationship_manager_relation?.relationship_manager_id?.name}
                  // onChange={handleContactChange}
                  // maxLength={10}
                  disabled
                />
              {/* </div> */}
            </Grid>
          }

          {leadDetails?.lead_product_relationship_manager_relation?.relationship_manager_id?.contact_number &&
            <Grid item md={4}>
              <div className="w-full">
                <CustomTextInputBasic
                  label="Contact Info"
                  name="contact"
                  type="text"
                  className="w-full -mt-1"
                  value={leadDetails?.lead_product_relationship_manager_relation?.relationship_manager_id?.contact_number}
                  // onChange={handleContactChange}
                  // maxLength={10}
                  disabled
                />
                {contactError && (
                  <p className="text-red-500 text-sm">{contactError}</p>
                )}
              </div>
            </Grid>
          }
        </Grid>

        {(loggedInUser?.user_id && !loggedInUser?.rm_id) &&
          <Grid container className="mt-6 mb-10">
            <Grid item xs={12} className="flex justify-end gap-3">
              {renderButtons}
            </Grid>
          </Grid>
        }
      </CustomPaperBox>

      {leadDetails &&
        <CustomPaperBox>
          <div className="p-4">
            <h3 className="font-semibold text-gray-800 mb-3">Lead servicing</h3>
            <AdminLeadEngagement
              lprId={leadDetails?.lpr_id || lead?.lpr_id || lead?.lead_product_relation_display_id}
              mobile={leadDetails?.lead_id?.contact_number}
              currentStatusId={leadDetails?.lead_status_id?.id}
              name={leadDetails?.lead_id?.name}
            />
          </div>
        </CustomPaperBox>
      }

      {assignRmModalData &&
        <AssignRelationshipManagerToLead
          leadDetails={leadDetails}
          actionType={assignRmModalData?.actionType}
          onClose={(_flag) => {
            if (_flag) {
              getLeadDetails();
            }
            setAssignRmModalData(null);
          }}
        />
      }
    </div>
  );
};

export default LeadDetailsPage;
